<template>
  <v-container v-if="access.includes(roles.crewlist)">
    <v-card
      class="mx-auto"
    >
      <v-card-title>
        <div class="primary--text">
          Crew List
        </div>
        <v-spacer />
        <v-col
          cols="12"
          sm="6"
          md="4"
        >
          <v-text-field
            v-model="search_input"
            append-icon="mdi-magnify"
            label="Search"
            class="menu-items"
            @keydown.enter="OnSearchInput"
          />
        </v-col>
        <v-btn
          color="primary"
          class="menu-items"
          @click="ShowNewCrew()"
        >
          New Crew
        </v-btn>
        <v-btn
          outlined
          class="mr-4"
          color="grey darken-2"
          @click="ShowUpload()"
        >
          Import Data from Excel
        </v-btn>
        <v-tooltip
          color="success"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              min-width="48px"
              style="padding:0px !important;"
              text
              :class="{ selected: profile_view }"
              v-bind="attrs"
              v-on="on"
              @click="profile_view = true"
            >
              <v-icon
                large
                :class="{ 'primary--text': profile_view }"
              >
                mdi-view-split-vertical
              </v-icon>
            </v-btn>
          </template>
          <span>Profile View</span>
        </v-tooltip>
        <!-- <v-tooltip
          color="success"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              min-width="48px"
              style="padding:0px !important"
              text
              :class="{ selected: !profile_view }"
              v-bind="attrs"
              v-on="on"
              @click="profile_view = false"
            >
              <v-icon
                large
                :class="{ 'primary--text': !profile_view }"
              >
                mdi-view-list
              </v-icon>
            </v-btn>
          </template>
          <span>List View</span>
        </v-tooltip> -->
      </v-card-title>
      <div>
        <v-data-table
          v-if="profile_view"
          :headers="headers_crew"
          :items="crew_items"
          :options.sync="options"
          :server-items-length="total"
          :loading="loading_crew"
          :loading-text="loading_text"
          class="elevation-1 text-no-wrap dense-2"
        >
          <template v-slot:[`header.status`]="{ header }">
            <v-menu
              open-on-hover
              bottom
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="filter-btn">
                    {{ header.text }}
                  </span>
                  <v-icon :class="{ 'filter-icon': true, filtered: StatusFiltered }">
                    mdi-menu-down
                  </v-icon>
                </div>
              </template>
              <v-list>
                <v-list-item-group
                  v-model="status_column"
                  color="primary"
                >
                  <v-list-item @click="SetStatusFilter(0)">
                    <v-list-item-title>Active</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="SetStatusFilter(1)">
                    <v-list-item-title>Inactive</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="SetStatusFilter(2)">
                    <v-list-item-title>All</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row
              align="center"
              justify="center"
            >
              <v-tooltip
                color="success"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    dark
                    x-small
                    color="cyan"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="EditCrew(item)"
                  >
                    <v-icon dark>
                      mdi mdi-pencil
                    </v-icon>
                  </v-btn>
                </template>
                <span>Edit Crew</span>
              </v-tooltip>
            </v-row>
          </template>
        </v-data-table>
        <v-data-table
          v-if="!profile_view"
          :headers="headers_crew_list"
          :items="crew_list_items"
          :options.sync="options"
          :server-items-length="total"
          :loading="loading_crew"
          :loading-text="loading_text"
          class="elevation-1 text-no-wrap dense-2"
        />
      </div>
    </v-card>
    <div class="py-3" />

    <!-- Edit crew dialog -->
    <v-dialog
      v-model="show_crew"
      persistent
      fullscreen
      :retain-focus="false"
      transition="dialog-bottom-transition"
      dense
      fixed
    >
      <v-card>
        <v-toolbar
          flat
          color="success"
          dark
        >
          <v-btn icon>
            <v-icon>mdi-account-box-multiple-outline</v-icon>
          </v-btn>
          <v-toolbar-title>{{ crew_title }}</v-toolbar-title>
          <v-spacer />
          <v-btn
            text
            dark
            :disabled="CanSaveCrew==1 && edited_crew.read_only==true"
            @click="SaveCrew()"
          >
            <v-icon icon>
              mdi-content-save-outline
            </v-icon>
            &nbsp;Save
          </v-btn>
          <v-btn
            text
            dark
            @click="show_crew=false"
          >
            <v-icon icon>
              mdi-close
            </v-icon>
            &nbsp;Close
          </v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 12px;padding-bottom: 0;">
          <v-tabs
            v-model="crew_tab"
            vertical
          >
            <v-tab
              v-for="(item, i) in menu_items"
              :key="i"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon" />
              </v-list-item-icon>
              <v-list-item-content class="text-left">
                <v-list-item-title v-text="item.text" />
              </v-list-item-content>
            </v-tab>
            <v-tab-item>
              <v-card>
                <v-card-text style="padding-top: 10px; height: 100%;">
                  <v-col>
                    <v-form
                      v-if="edited_crew"
                      ref="edit_crew_form"
                      lazy-validation
                      :readonly="edited_crew.read_only"
                      style="padding-left:10px"
                      class="elevation-4 text-no-wrap dense-2"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-if="!edited_crew.read_only"
                            v-model="edited_crew.personnelidno"
                            label="PERSONNELIDNO"
                            :counter="10"
                            :rules="[
                              v => !!v || 'This is required',
                              v => v.length ==0 || (v.length == 10 && /^\d*$/.test(v)) || 'Must be 10 characters long, all numeric.'
                            ]"
                          />
                          <v-text-field
                            v-if="edited_crew.read_only"
                            v-model="edited_crew.personnelidno"
                            label="PERSONNELIDNO"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="edited_crew.last_name"
                            label="Last Name"
                            :rules="[
                              v => !!v || 'This is required',
                              v => !!v && v.length <= 30 || 'Max input of 30 characters only.'
                            ]"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="edited_crew.first_name"
                            label="First Name"
                            :rules="[
                              v => !!v || 'This is required',
                              v => !!v && v.length <= 30 || 'Max input of 30 characters only.'
                            ]"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="edited_crew.middle_name"
                            label="Middle Name"
                            :rules="[
                              v => v.length >= 0 && v.length <= 30 || 'Max input of 30 characters only.'
                            ]"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="edited_crew.nick_name"
                            label="Nick Name"
                            :rules="[
                              v => !!v || 'This is required',
                              v => !!v && v.length <= 30 || 'Max input of 30 characters only.'
                            ]"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-menu
                            v-if="!edited_crew.read_only"
                            v-model="date_menu_2"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="edited_crew.date_hired"
                                label="Date Hired"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              v-model="edited_crew.date_hired"
                              @input="date_menu_2 = false"
                            />
                          </v-menu>
                          <v-text-field
                            v-if="edited_crew.read_only"
                            v-model="edited_crew.date_hired"
                            label="Date Hired"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-select
                            v-if="!edited_crew.read_only"
                            v-model="edited_crew.position_code"
                            label="Position"
                            :items="position_codes"
                            :rules="[
                              v => !!v || 'This is required'
                            ]"
                          />
                          <v-text-field
                            v-if="edited_crew.read_only"
                            v-model="edited_crew.position_code"
                            label="Position"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-select
                            v-if="!edited_crew.read_only"
                            v-model="edited_crew.employment_status"
                            label="Status"
                            :items="employment_status_all"
                            :rules="[
                              v => !!v || 'This is required'
                            ]"
                          />
                          <v-text-field
                            v-if="edited_crew.read_only"
                            v-model="edited_crew.employment_status"
                            label="Status"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-if="!edited_crew.read_only"
                            v-model="edited_crew.current_amount"
                            label="Current Amount"
                            type="number"
                            hint="Rate is 60% - GADC and 40% - DOLE for SPES, Senior Citizens and Jobstarter employee."
                            :rules="[
                              v => !!v || 'This is required',
                            ]"
                          />
                          <v-text-field
                            v-if="edited_crew.read_only"
                            v-model="edited_crew.current_amount"
                            label="Current Amount"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-if="!edited_crew.read_only"
                            v-model="edited_crew.cola_amount"
                            label="COLA Amount"
                            type="number"
                            :rules="[
                              v => !isNaN(parseFloat(v)) && v >= 0 || 'This is required',
                            ]"
                          />
                          <v-text-field
                            v-if="edited_crew.read_only"
                            v-model="edited_crew.cola_amount"
                            label="COLA Amount"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text style="padding-top: 0px;padding-bottom: 0;">
                  <v-col>
                    <v-data-table
                      :headers="headers_trained_areas"
                      :items="crew_trained_areas"
                      :loading="loading_trained_areas"
                      :disable-sort="true"
                      :loading-text="loading_text"
                      group-by="name"
                      fixed-header
                      height="calc(100vh - 120px)"
                      disable-pagination
                      hide-default-header
                      hide-default-footer
                      class="elevation-4 text-no-wrap dense-2"
                    >
                      <template v-slot:header="{ props }">
                        <thead class="v-data-table-header">
                          <tr>
                            <th
                              v-for="(header, index) in props.headers"
                              :key="header.text + index"
                              role="columnheader"
                              scope="col"
                              :class="{'text-start title': true, hidden: index==2}"
                              :colspan="index==0?2:1"
                              :aria-label="header.text"
                            >
                              <span>{{ header.text }}</span>
                            </th>
                          </tr>
                        </thead>
                      </template>
                      <template v-slot:[`group.header`]="{ group }">
                        <td
                          :colspan="headers_trained_areas.length"
                          class="teal"
                          style="text-transform: uppercase;"
                        >
                          <strong>
                            {{ group }}
                          </strong>
                        </td>
                      </template>
                      <template v-slot:[`item`]="{ item }">
                        <tr class="dark-row">
                          <template
                            v-for="(v,k) in item"
                          >
                            <td
                              v-if="k == 'name'"
                              :key="v+k"
                            />
                            <td
                              v-if="k == 'station'"
                              :key="v+k"
                            >
                              <strong>
                                {{ v }}
                              </strong>
                            </td>
                            <td
                              v-if="typeof item[k] == 'boolean'"
                              :key="v+k"
                            >
                              <v-checkbox
                                v-model="item[k]"
                                color="success"
                                style="margin-top:0"
                                hide-details
                              />
                            </td>
                          </template>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text style="padding-top: 0px;padding-bottom: 0;">
                  <v-col>
                    <v-data-table
                      :headers="headers_time_availability"
                      :items="crew_time_availability"
                      :loading="loading_time_availability"
                      :loading-text="loading_text"
                      :disable-sort="true"
                      :disable-pagination="true"
                      :hide-default-footer="true"
                      class="elevation-4 text-no-wrap modal-table dense-2"
                    >
                      <template v-slot:[`item.total_hours`]="{ item }">
                        {{ GetTimeSpanTA(item.time_availability) }}
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <div class="row">
                          <v-btn
                            small
                            color="primary"
                            @click.stop="EditTimeAvailability(item)"
                          >
                            Edit
                          </v-btn>
                          <v-btn
                            small
                            color="error"
                            class="ml-2"
                            @click.stop="ClearTimeAvailability(item)"
                          >
                            Clear
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End edit crew dialog -->

    <!-- Edit time availability dialog -->
    <v-dialog
      v-model="show_shift_master"
      width="70%"
      max-width="70%"
    >
      <v-card>
        <v-card-title class="text-start">
          <h1 class="primary--text text-start">
            Shift Master
          </h1>
        </v-card-title>
        <v-container>
          <v-data-table
            :headers="headers_shift_master"
            :items="shift_master"
            :loading="loading_shift_master"
            :loading-text="loading_text"
            :disable-sort="true"
            :disable-pagination="true"
            :hide-default-footer="true"
            class="elevation-1 text-no-wrap dense-2"
          >
            <template v-slot:[`item.total_hours`]="{ item }">
              {{ GetTimeSpan(item.start_time, item.end_time) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="row">
                <v-btn
                  small
                  color="primary"
                  :disabled="!edited_crew.read_only && item.night_shift && !allow_temp_crew_night_shift"
                  @click.stop="SelectTimeAvailability(item)"
                >
                  Select
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-container>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="show_shift_master = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End edit time availability dialog -->

    <!-- New crew dialog -->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="show_new_crew"
          width="90%"
          max-width="90%"
        >
          <v-form
            ref="new_crew_form"
            lazy-validation
          >
            <v-card>
              <v-card-title class="text-left">
                <v-row>
                  <h2 class="primary--text">
                    New Crew
                  </h2>
                </v-row>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      ref="personnelidno"
                      v-model="new_crew.personnelidno"
                      :counter="10"
                      label="PERSONNELIDNO"
                      :rules="[
                        v => !!v || 'This is required',
                        v => v.length ==0 || (v.length == 10 && /^\d*$/.test(v)) || 'Must be 10 characters long, all numeric.'
                      ]"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="new_crew.last_name"
                      label="Last Name"
                      :rules="[
                        v => !!v || 'This is required',
                        v => !!v && v.length <= 30 || 'Max input of 30 characters only.'
                      ]"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="new_crew.first_name"
                      label="First Name"
                      :rules="[
                        v => !!v || 'This is required',
                        v => !!v && v.length <= 30 || 'Max input of 30 characters only.'
                      ]"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="new_crew.middle_name"
                      label="Middle Name"
                      :rules="[
                        v => v.length >= 0 && v.length <= 30 || 'Max input of 30 characters only.'
                      ]"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="new_crew.nick_name"
                      label="Nick Name"
                      :rules="[
                        v => !!v || 'This is required',
                        v => !!v && v.length <= 30 || 'Max input of 30 characters only.'
                      ]"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-menu
                      v-model="date_menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="new_crew.date_hired"
                          label="Date Hired"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="new_crew.date_hired"
                        @input="date_menu = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-select
                      v-model="new_crew.position_code"
                      label="Position"
                      :items="position_codes"
                      :rules="[
                        v => !!v || 'This is required'
                      ]"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-select
                      v-model="new_crew.employment_status"
                      label="Status"
                      :items="employment_status"
                      :rules="[
                        v => !!v || 'This is required'
                      ]"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="new_crew.current_amount"
                      label="Current Amount"
                      type="number"
                      hint="Rate is 60% - GADC and 40% - DOLE for SPES, Senior Citizens and Jobstarter employee."
                      :rules="[
                        v => !!v || 'This is required',
                      ]"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="new_crew.cola_amount"
                      label="COLA Amount"
                      type="number"
                      :rules="[
                        v => !isNaN(parseFloat(v)) && v >= 0 || 'This is required',
                      ]"
                    />
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="green darken-1"
                  text
                  @click="SaveNewCrew()"
                >
                  Save
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="show_new_crew = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-row>
    </template>
    <!-- End new crew dialog -->

    <!-- Upload file dialog -->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="show_upload"
          width="50%"
          max-width="50%"
        >
          <v-card>
            <v-card-title class="text-left">
              <v-row>
                <h2 class="primary--text">
                  Import Crewlist Data
                </h2>
              </v-row>
            </v-card-title>
            <v-card-text>
              <template>
                <v-file-input
                  v-model="excel_file"
                  show-size
                  label="Click here to browse your file"
                  accept=".xlsx"
                />
              </template>
              <v-btn
                color="green darken-1"
                text
                plain
                style="text-decoration: underline;opacity:1;"
                :disabled="in_process"
                href="https://escheduling.mcd.com.ph/crewlist_template.xlsx"
                target="_blank"
                download
              >
                Download template
              </v-btn>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text
                :disabled="in_process"
                @click="UploadFile()"
              >
                Upload
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                :disabled="in_process"
                @click="show_upload = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- End upload file dialog -->
  </v-container>
</template>
<script>
  import moment from 'moment'
  import {
    mapState,
  } from 'vuex'
  import {
    GetCrew,
    CreateNewCrew,
    GetCrewOptions,
    UpdateCrew,
  } from '@/graphql/Crew.gql'
  import {
    GetCrewTrainedAreas,
    UpdateCrewTrainedAreas,
  } from '@/graphql/TrainedArea.gql'
  import {
    GetCrewTimeAvailability,
    UpdateCrewTimeAvailability,
  } from '@/graphql/TimeAvailability.gql'
  import {
    GetShiftMasters,
  } from '@/graphql/ShiftMaster.gql'
  import {
    UploadFile,
  } from '@/graphql/File.gql'
  export default {
    data () {
      return {
        // rebuild
        total: 0,
        crew_items: [],
        crew_list_items: [],
        crew_trained_areas: [],
        crew_time_availability: [],
        shift_master: [],
        loading_crew: true,
        loading_trained_areas: true,
        loading_time_availability: true,
        loading_shift_master: true,
        loading_text: 'Please wait while loading data...',
        stations: ['asd', 'eee', 'sss'],
        crew_stations: [],
        options: {
          page: 1,
          itemsPerPage: 10,
        },
        headers_crew: [
          { text: 'PERSONNELIDNO', value: 'personnelidno', class: 'title' },
          { text: 'Last Name', value: 'last_name', class: 'title' },
          { text: 'First Name', value: 'first_name', class: 'title' },
          { text: 'Middle Name', value: 'middle_name', class: 'title' },
          { text: 'Nick Name', value: 'nick_name', class: 'title' },
          { text: 'Date Hired', value: 'date_hired', class: 'title' },
          { text: 'Position', value: 'position_code', class: 'title' },
          { text: 'Status', value: 'employment_status', class: 'title' },
          { text: 'Rate', value: 'current_amount', class: 'title' },
          { text: 'Cola', value: 'cola_amount', class: 'title' },
        ],
        headers_time_availability: [
          { text: 'Work Day', sortable: false, value: 'day', class: 'title' },
          { text: 'Time Availability', sortable: false, value: 'time_availability', class: 'title' },
          { text: 'Total Hours', sortable: false, value: 'total_hours', class: 'title' },
          { text: 'Actions', sortable: false, value: 'actions', class: 'title' },
        ],
        headers_shift_master: [
          { text: 'Shift Name', sortable: false, value: 'name', class: 'title', filterable: false },
          { text: 'Start Time', sortable: false, value: 'start_time', class: 'title' },
          { text: 'End Time', sortable: false, value: 'end_time', class: 'title', filterable: false },
          { text: 'Total Hours', sortable: false, value: 'total_hours', class: 'title', filterable: false },
          { text: 'Actions', sortable: false, value: 'actions', class: 'title' },
        ],
        headers_trained_areas: [
          { text: 'Name', value: 'name' },
          { text: 'Stations', value: 'station' },
          { text: 'Assign', value: 'assign' },
        ],
        skip_crew: true,
        skip_trained_areas: true,
        skip_time_availability: true,
        skip_shift_master: true,
        search: '',
        search_input: '',
        crew_title: '',
        show_crew: false,
        show_shift_master: false,
        show_new_crew: false,
        crew_tab: 1,
        edited_crew: [],
        new_crew: {},
        edited_time_availability: null,
        last_edit_id: '',
        crew_hash: '',
        crew_trained_area_hash: '',
        shiftmasters_hash: '',
        profile_view: true,
        date_menu: false,
        date_menu_2: false,
        position_codes: ['SPES'],
        employment_status: ['PROBATIONARY'],
        employment_status_all: ['PROBATIONARY'],
        loading_new_crew_options: true,
        skip_new_crew_options: true,
        allow_temp_crew_night_shift: false,
        show_upload: false,
        excel_file: null,
        default_shift: null,
        menu_items: [
          { text: 'Profile', icon: 'mdi-account-tie' },
          { text: 'Trained Areas', icon: 'mdi-format-list-bulleted-square' },
          { text: 'Time Availability', icon: 'mdi-timetable' },
        ],
      }
    },
    computed: {
      ...mapState(['in_process', 'default_error', 'access', 'roles']),
      StatusFiltered () {
        return (this.status_filter !== 2)
      },
      CanSaveCrew () {
        return (this.crew_tab === 0)
      },
    },
    watch: {
      options: {
        handler () {
          this.GetCrew()
        },
        deep: true,
      },
    },
    mounted () {
      window.scrollTo(0, 0)
      this.headers_crew_list = JSON.parse(JSON.stringify(this.headers_crew))
      this.headers_crew.push({ text: 'Actions ', sortable: false, value: 'actions', class: 'title' })
      this.GetCrew()
      this.GetShiftMasters()
      this.GetCrewOptions()
    },
    methods: {
      ShowNewCrew () {
        if (!this.access.includes(this.roles.crewlist_manage_crew) &&
          !this.access.includes(this.roles.crewlist_manage_spes)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.show_new_crew = true
      },
      ShowUpload () {
        if (!this.access.includes(this.roles.crewlist_import)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.show_upload = true
      },
      GetTimeSpanTA (s) {
        if (s === 'WEEKLY OFF' || s === 'NO TIME AVAILABILITY') return '0'
        var sch = s.split('-')
        return this.GetTimeSpan(sch[0], sch[1])
      },
      GetCrew () {
        this.loading_crew = true
        this.crew_items = []
        this.skip_crew = false
      },
      GetCrewTrainedAreas () {
        this.loading_trained_areas = true
        this.skip_trained_areas = false
        this.trained_areas = []
        this.crew_trained_areas = []
        if (this.last_edit_id === this.edited_crew.personnelidno) {
          this.$apollo.queries.GetCrewTrainedAreas.refetch()
        }
      },
      GetCrewTimeAvailability () {
        this.loading_time_availability = true
        this.skip_time_availability = false
        this.crew_time_availability = []
        if (this.last_edit_id === this.edited_crew.personnelidno) {
          this.$apollo.queries.GetCrewTimeAvailability.refetch()
        }
      },
      GetShiftMasters () {
        this.loading_shift_master = true
        this.skip_shift_master = false
        this.shift_master = []
      },
      GetCrewOptions () {
        this.loading_new_crew_options = true
        this.skip_new_crew_options = false
        this.position_codes = []
        this.employment_status = []
        this.employment_status_all = []
      },
      SetNewCrewData () {
        this.new_crew = {
          personnelidno: '',
          last_name: '',
          first_name: '',
          middle_name: '',
          nick_name: '',
          date_hired: moment().format('YYYY-MM-DD'),
          position_code: this.position_codes[0],
          employment_status: this.employment_status[0],
          current_amount: 0,
          cola_amount: 0,
        }
      },
      SaveNewCrew () {
        if (!this.$refs.new_crew_form.validate()) {
          this.$store.commit('ShowError', 'Please check your input!')
          return
        }
        this.$store.commit('Notify', 'Creating record...')
        this.$apollo.mutate({
          mutation: CreateNewCrew,
          variables: {
            input: this.new_crew,
          },
        }).then((res) => {
          if (res.data.CreateNewCrew.status === 'Ok') {
            this.SetNewCrewData()
            this.GetCrew()
            this.$refs.new_crew_form.resetValidation()
            this.show_new_crew = false
            this.$store.commit('CloseAlert', '')
          } else if (res.data.CreateNewCrew.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.CreateNewCrew.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      SaveCrew () {
        if (this.crew_tab === 0) { /* crew profile */
          if (this.edited_crew.read_only) return
          if (!this.$refs.edit_crew_form.validate()) {
            this.$store.commit('ShowError', 'Please check your input!')
            return
          }
          var input = JSON.parse(JSON.stringify(this.edited_crew))
          input.hash = this.crew_hash
          delete input.__typename
          delete input.read_only
          this.$store.commit('Notify', 'Updating record...')
          this.$apollo.mutate({
            mutation: UpdateCrew,
            variables: {
              input: input,
            },
          }).then((res) => {
            if (res.data.UpdateCrew.status === 'Ok') {
              if (!res.data.UpdateCrew.active) { this.GetCrew() }
              this.$refs.edit_crew_form.resetValidation()
              this.$store.commit('CloseAlert', '')
              this.show_crew = res.data.UpdateCrew.active
            } else if (res.data.UpdateCrew.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', res.data.UpdateCrew.status)
            }
          }).catch(error => {
            this.CheckError(error)
          })
        } else if (this.crew_tab === 1) { /* crew trained areas */
          this.$store.commit('Notify', '')
          this.$apollo.mutate({
            mutation: UpdateCrewTrainedAreas,
            variables: {
              uid: this.edited_crew.uid,
              hash: this.crew_hash,
              cta_hash: this.crew_trained_area_hash,
              trained_areas: JSON.stringify(this.crew_trained_areas),
            },
          }).then((res) => {
            if (res.data.UpdateCrewTrainedAreas.status === 'Ok') {
              this.$store.commit('CloseAlert', '')
            } else if (res.data.UpdateCrewTrainedAreas.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', res.data.UpdateCrewTrainedAreas.status)
            }
          }).catch(error => {
            this.CheckError(error)
          })
        } else if (this.crew_tab === 2) { /* crew time availability */
          this.$store.commit('Notify', '')
          this.$apollo.mutate({
            mutation: UpdateCrewTimeAvailability,
            variables: {
              uid: this.edited_crew.uid,
              hash: this.crew_hash,
              time_availability: this.crew_time_availability.map((item) => {
                const _item = Object.assign({}, item)
                delete _item.__typename
                return _item
              }),
            },
          }).then((res) => {
            if (res.data.UpdateCrewTimeAvailability.status === 'Ok') {
              this.$store.commit('CloseAlert', '')
              this.GetCrewTimeAvailability()
            } else if (res.data.UpdateCrewTimeAvailability.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', res.data.UpdateCrewTimeAvailability.status)
            }
          }).catch(error => {
            this.CheckError(error)
          })
        }
      },
      EditCrew (crew) {
        this.crew_title = crew.personnelidno + ' - ' + crew.last_name + ', ' + crew.first_name + ' ' + crew.middle_name
        this.crew_tab = 0
        this.show_crew = true
        if (this.edited_crew.length !== 0) {
          this.last_edit_id = this.edited_crew.personnelidno
        }
        this.edited_crew = crew
        this.GetCrewTrainedAreas()
        this.GetCrewTimeAvailability()
      },
      EditTimeAvailability (item) {
        this.edited_time_availability = item
        this.show_shift_master = true
      },
      SelectTimeAvailability (item) {
        this.edited_time_availability.uid = item.uid
        this.edited_time_availability.hash = this.shiftmasters_hash
        this.edited_time_availability.time_availability = item.name
        this.show_shift_master = false
      },
      ClearTimeAvailability (item) {
        item.uid = this.default_shift.uid
        item.hash = this.shiftmasters_hash
        item.time_availability = this.default_shift.name
      },
      OnSearchInput () {
        this.search = this.search_input
        this.options.page = 1
        this.GetCrew()
      },
      SetStatusFilter (f) {
        if (this.status_filter !== f) {
          this.crew_items = []
          this.loading_crew = true
          this.status_filter = f
        }
      },
      UploadFile () {
        const crewlist = 201
        if (!this.excel_file) {
          this.$store.commit('ShowError', 'Please select file to upload.')
          return
        }
        this.$store.commit('Notify', 'Uploading file...')
        this.$apollo.mutate({
          mutation: UploadFile,
          variables: {
            file: this.excel_file,
            type: crewlist,
          },
        }).then((res) => {
          if (res.data.UploadFile.status === 'Ok') {
            this.$store.commit('CloseAlert', '')
            this.show_upload = false
            this.excel_file = null
            this.GetCrew()
          } else if (res.data.UploadFile.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.UploadFile.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
    },
    apollo: {
      GetCrew: {
        error (error) {
          this.loading_crew = false
          this.CheckError(error)
        },
        query: GetCrew,
        variables () {
          return {
            per_page: this.options.itemsPerPage || 10,
            page: this.options.page || 1,
            search: this.search,
          }
        },
        skip () {
          return this.skip_crew
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.GetCrew && data.GetCrew.status === 'Ok') {
              this.crew_items = data.GetCrew.data
              this.crew_hash = data.GetCrew.hash
              this.total = data.GetCrew.total
            } else if (data.GetCrew.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            }
            this.loading_crew = false
            this.skip_crew = true
          }
        },
      },

      GetCrewTrainedAreas: {
        error (error) {
          this.loading_trained_areas = false
          this.CheckError(error)
        },
        query: GetCrewTrainedAreas,
        variables () {
          return {
            uid: this.edited_crew.uid,
            hash: this.crew_hash,
          }
        },
        skip () {
          return this.skip_trained_areas
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetCrewTrainedAreas.status === 'Ok') {
              this.crew_trained_area_hash = data.GetCrewTrainedAreas.hash
              this.crew_trained_areas = data.GetCrewTrainedAreas.data
            } else if (data.GetCrewTrainedAreas.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            }
            this.loading_trained_areas = false
            this.skip_trained_areas = true
          }
        },
      },

      GetCrewTimeAvailability: {
        error (error) {
          this.loading_time_availability = false
          this.CheckError(error)
        },
        query: GetCrewTimeAvailability,
        variables () {
          return {
            uid: this.edited_crew.uid,
            hash: this.crew_hash,
          }
        },
        skip () {
          return this.skip_time_availability
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetCrewTimeAvailability) {
              this.crew_time_availability = data.GetCrewTimeAvailability.data.map((item) => {
                const _item = Object.assign({}, item)
                _item.hash = data.GetCrewTimeAvailability.hash
                return _item
              })
              this.loading_time_availability = false
              this.skip_time_availability = true
            }
          }
        },
      },
      GetCrewOptions: {
        error (error) {
          this.loading_new_crew_options = false
          this.CheckError(error)
        },
        query: GetCrewOptions,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_new_crew_options
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetCrewOptions.position_codes) {
              this.position_codes = data.GetCrewOptions.position_codes.split(',')
              this.employment_status = data.GetCrewOptions.employment_status.split(',')
              this.employment_status_all = [...this.employment_status, ...data.GetCrewOptions.employment_status_inactive.split(',')]
              this.loading_new_crew_options = false
              this.skip_new_crew_options = true
              this.SetNewCrewData()
            }
          }
        },
      },
      GetShiftMasters: {
        error (error) {
          this.loading_shift_master = false
          this.CheckError(error)
        },
        query: GetShiftMasters,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_shift_master
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetShiftMasters) {
              this.shift_master = data.GetShiftMasters.data
              this.shiftmasters_hash = data.GetShiftMasters.hash
              this.allow_temp_crew_night_shift = data.GetShiftMasters.allow_temp_crew_night_shift
              this.loading_shift_master = false
              this.skip_shift_master = true
              // check default shift
              for (const index in this.shift_master) {
                if (this.shift_master[index].uid === data.GetShiftMasters.default_id) {
                  this.default_shift = JSON.parse(JSON.stringify(this.shift_master[index]))
                  this.shift_master.splice(index, 1)
                }
              }
            }
          }
        },
      },
    },
  }
</script>
